export const Navigation = {
  methods: {
    openProject(id) {
      this.$router.push(`project/${id}`);
    },
  },
};
